import { atom } from "recoil";
import { UserNotification } from "../entities/user-notification";

export const notificationAtom = atom({
  key: "notificationAtom",
  default: undefined as UserNotification | undefined,
});
